module.exports = __webpack_public_path__ + "static/leadcapture-51c79e674bbed5ca2c3c2eff8e6448da.svg";